module.exports = __webpack_public_path__ + "media/images/logo/vac-5ff837b6251a6729e725a2078168a4e6.png";